import { useContext, useContextSelector } from 'use-context-selector';
import { HeaderContext } from './HeaderContext';

const useHeaderState = () => {
  const context = useContext(HeaderContext);

  if (context === undefined) {
    throw new Error('useHeaderState must be used within HeaderProvider');
  }

  return context;
};

const useHasDivider = () => {
  const context = useContextSelector(HeaderContext, state => state.hasDivider);

  if (context === undefined) {
    throw new Error('useHasDivider must be used within HeaderProvider');
  }

  return context;
};

const useOnSetHasDivider = () => {
  const context = useContextSelector(HeaderContext, state => state.onSetHasDivider);

  if (context === undefined) {
    throw new Error('useOnSetHasDivider must be used within HeaderProvider');
  }

  return context;
};

export { useHeaderState, useHasDivider, useOnSetHasDivider };
